import axios from "axios";
import { config, getDomain, tempAlErr, tempAlWait } from "../helpers"
import { alertIndex } from "../helpers/alertIndex";
import { PARC_ACT, PARC_DEL, PARC_DET, PARC_ENABLE, PARC_LIST, PARC_SAVE } from "./action-types";

// Liste des parcs
export function listParc() {
    return function (dispatch) {
        let alert = tempAlWait();
        let datas = [];
        let url = `${getDomain()}api/parcs`;

        axios.post(url, {}, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                if (res.res.type == "succ") {
                    datas = res.datas;
                }

                dispatch({
                    type: PARC_LIST,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("pali002");
                dispatch({
                    type: PARC_LIST,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
    }
}

// Liste des parcs actifs
export function listParcActive() {
    return function (dispatch) {
        let alert = tempAlWait();
        let datas = [];
        let url = `${getDomain()}api/waitime/parcs`;

        axios.post(url, {}, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                if (res.res.type == "succ") {
                    datas = res.datas;
                }

                dispatch({
                    type: PARC_ACT,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("wapa002");
                
                dispatch({
                    type: PARC_ACT,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
    }
}

// Détails d'un parc
export function detailsParc({parcId}) {
    return function (dispatch) {
        let alert = tempAlWait();
        let datas = null;
        let url = `${getDomain()}api/parc/${parcId}`;

        axios.post(url, {}, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                if (res.res.type == "succ") {
                    datas = res.datas;
                }

                dispatch({
                    type: PARC_DET,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("padt002");
                dispatch({
                    type: PARC_DET,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
    }
}

// Sauvegarde d'un parc
export function saveParc({
    parcId,
    name,
    isActive,
    id = null
}) {
    return function (dispatch) {
        let alert = tempAlWait();
        let isNext = false;
        let url = `${getDomain()}api/parcs/save`;

        if (id != null) {
            url += `/${id}`;
        }

        axios.post(url, {
            parcId: parcId,
            name: name,
            isActive: isActive,
            credentials: localStorage.getItem('userCred'),
            userId: localStorage.getItem('userId')
        }, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                if (res.res.type == "succ") {
                    isNext = true;
                }

                dispatch({
                    type: PARC_SAVE,
                    payload: {
                        alert: alert,
                        isNext: isNext
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("pasa005");
                dispatch({
                    type: PARC_SAVE,
                    payload: {
                        alert: alert,
                        isNext: isNext
                    }
                })
            })
    }
}

// Suppression d'un parc
export function deleteParc({id}) {
    return function (dispatch) {
        let alert = tempAlWait();
        let isNext = false;
        let url = `${getDomain()}api/parcs/delete/${id}`;

        axios.post(url, {
            userId: localStorage.getItem('userId'),
            credentials: localStorage.getItem('userCred')
        }, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                if (res.res.type == "succ") {
                    isNext = true;
                }

                dispatch({
                    type: PARC_DEL,
                    payload: {
                        alert: alert,
                        isNext: isNext
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("pade004");
                dispatch({
                    type: PARC_DEL,
                    payload: {
                        alert: alert,
                        isNext: isNext
                    }
                })
            })
    }
}

// Sauvegarde activer/désactiver parc
export function setEnableParc({parcId, isActive}) {
    return function (dispatch) {
        let alert = tempAlWait();
        let isNext = false;
        let url = `${getDomain()}api/enable-parc/${parcId}`;

        axios.post(url, {
            userId: localStorage.getItem('userId'),
            credentials: localStorage.getItem('userCred'),
            isActive: isActive
        }, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.code);

                if (res.type == "succ") {
                    isNext = true;
                }

                dispatch({
                    type: PARC_ENABLE,
                    payload: {
                        alert: alert,
                        isNext: isNext
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("paen004");
                dispatch({
                    type: PARC_ENABLE,
                    payload: {
                        alert: alert,
                        isNext: isNext
                    }
                })
            })
    }
}